// import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(axios)
// Vue.use(VueAxios)
import axios from '@/plugins/axios'

export default {
  install(Vue) {
    Vue.prototype.$weeklyApiService = {
      weekly_api_url: `${process.env.VUE_APP_EPAPER_API_URL}/weeklies`,

      /**
       * 查詢
       * @param {string} param - API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async query(param = '') {
        const url = `${this.weekly_api_url}`
        const params = param ? `?${param}` : ''
        const response = await axios.get(`${url}${params}`)
        return response.data
      },

      /**
       * 取得出版年份清單
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getListOfPublicationYear() {
        const response = await axios.get(`${this.weekly_api_url}/publication-year`)
        return response.data
      }
    }
  }
}
